export default __webpack_public_path__ + "static/media/back.82acd76f.svg";